<div class="shop-sections">
  <div class="intro">
    Curated Shop rails. Rebuilt automatically every Sunday at 04:00 — use these to seed a
    new environment, redo a bad pass, or check it now.
  </div>

  @if (active(); as lock) {
    <div class="running">
      <div class="running-head">
        <mat-icon inline>autorenew</mat-icon>
        <span
          >Rebuilding on {{ lock.host }}{{ lock.isThisInstance ? ' (this instance)' : '' }} —
          started {{ lock.startedAt | date: 'short' }}</span
        >
        <button mat-button (click)="cancel()" [disabled]="lock.cancelRequested">
          {{ lock.cancelRequested ? 'Stopping…' : 'Cancel' }}
        </button>
      </div>
      <mat-progress-bar
        [mode]="lock.total ? 'determinate' : 'indeterminate'"
        [value]="progress()"
      ></mat-progress-bar>
      @if (lock.total) {
        <div class="muted">{{ lock.done }} / {{ lock.total }} — {{ lock.currentTitle }}</div>
      }
    </div>
  } @else {
    <div class="actions">
      <button
        mat-raised-button
        color="primary"
        (click)="start(true)"
        [disabled]="busy()"
        matTooltip="53 rule-based sections. No DeepSeek calls, about a minute."
      >
        Rebuild rule sections
      </button>
      <button
        mat-stroked-button
        (click)="start(false)"
        [disabled]="busy()"
        matTooltip="Includes the DeepSeek pass over every livestock listing. Roughly 25 minutes and real API spend."
      >
        Full rebuild (with AI)
      </button>
    </div>
  }

  @if (message()) {
    <div class="muted">{{ message() }}</div>
  }
  @if (error()) {
    <div class="error">{{ error() }}</div>
  }
</div>
